import { createContext } from "react";

export const LeagueContext = createContext({
  leagueCode: "",
  sponsorChecked: "",
  triggerClassicPublicLeagueRefetch: false,
  isLeagueMarketingPage: false,
  leagueInfoSuccessData: {},
  updateLeagueCode: () => {},
  updateSponsorChecked: () => {},
  updateTriggerClassicPublicLeagueRefetch: () => {},
  updateIsLeagueMarketingPage: () => {},
  updateLeagueInfoSuccessData: () => {},
});
